import {
  getAgentTeamMembershipNameByLevel,
} from '$/domains/teamAgent/membershipInfo';
import type { AgentTeamMembershipInfoItem } from '$/domains/teamAgent/type';
import type { TeamListItem } from './types';

export type TeamPackageBadgeVariant = 'free' | 'standard' | 'premium' | 'flagship' | 'platinum' | 'blackGold';

export type TeamPackageLike = Pick<TeamListItem, 'level'>;

const TEAM_PACKAGE_LEVEL_BADGE_VARIANT_MAP: Partial<Record<number, TeamPackageBadgeVariant>> = {
  1: 'standard',
  2: 'standard',
  3: 'premium',
  4: 'flagship',
  5: 'platinum',
  6: 'blackGold',
};

/** 按外部传入的会员等级解析接口映射文案，不接收调用方传入的名称。 */
export function getTeamPackageDisplayLabel(
  level?: number,
  membershipInfos?: AgentTeamMembershipInfoItem[],
): string | undefined {
  return getAgentTeamMembershipNameByLevel(level, membershipInfos);
}

/** 根据后端会员等级选择 Figma 会员标签背景变量，不依赖本地化展示文案。 */
export function getTeamPackageBadgeVariant(
  level?: number,
): TeamPackageBadgeVariant {
  return TEAM_PACKAGE_LEVEL_BADGE_VARIANT_MAP[Number(level)] || 'free';
}
